import { Component, Input } from '@angular/core';
import { SimpleModalComponent } from 'ngx-simple-modal';

export interface DefaultModalModel {
  title?: string;
  message: string;
}

@Component({
  selector: 'modal-cash-back',
  templateUrl: './modal-cash-back.component.html',
  styleUrls: ['./modal-cash-back.component.css']
})
export class ModalCashBackComponent extends SimpleModalComponent<DefaultModalModel, boolean> {
  valor = 1.00

  steps = [
    4,
    9,
    15,
    22,
    30,
    39,
    49,
    60,
    72,
    85,
    99,
    114,
    129,
    144,
    159,
    174,
    189,
    204,
    219,
    234,
    249,
    264,
    279,
    294,
    309
  ]

  stepsMounted = []

  constructor() {
    super();
    this.mountSteps()
  }

  mountSteps() {
    let total = 0
    let value = 0
    this.steps.forEach((d, i) => {
      value = i === 0 ? d * this.valor : (d * this.valor) - (this.steps[i - 1] * this.valor)
      total += value
      this.stepsMounted.push([d, value, total])
    })
  }

  fechar () {
    this.close()
  }
}
